// Mock data for Propitstop.in

export const services = [
  {
    id: '1',
    name: 'Periodic Services',
    icon: 'Wrench',
    description: 'Regular maintenance to keep your car running smoothly',
    image: 'https://images.unsplash.com/photo-1487754180451-c456f719a1fc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHw0fHxjYXIlMjBzZXJ2aWNlfGVufDB8fHx8MTc2MTgzMjk4N3ww&ixlib=rb-4.1.0&q=85',
    popular: true,
    packages: [
      { name: 'Basic Service', price: 2499, duration: '2-3 hours' },
      { name: 'Standard Service', price: 4499, duration: '3-4 hours' },
      { name: 'Comprehensive Service', price: 6999, duration: '4-5 hours' }
    ]
  },
  {
    id: '2',
    name: 'AC Service & Repair',
    icon: 'Wind',
    description: 'Complete AC servicing and repair solutions',
    image: 'https://images.unsplash.com/photo-1615906655593-ad0386982a0f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwxfHxtZWNoYW5pY3xlbnwwfHx8fDE3NjE4MzI5OTJ8MA&ixlib=rb-4.1.0&q=85',
    popular: true,
    packages: [
      { name: 'AC Gas Top Up', price: 1999, duration: '1-2 hours' },
      { name: 'Complete AC Service', price: 2999, duration: '2-3 hours' },
      { name: 'AC Repair', price: 3999, duration: '3-4 hours' }
    ]
  },
  {
    id: '3',
    name: 'Denting & Painting',
    icon: 'PaintBucket',
    description: 'Professional denting and painting services',
    image: 'https://images.unsplash.com/photo-1727893119356-1702fe921cf9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwyfHxjYXIlMjBzZXJ2aWNlfGVufDB8fHx8MTc2MTgzMjk4N3ww&ixlib=rb-4.1.0&q=85',
    popular: false,
    packages: [
      { name: 'Minor Dent Repair', price: 1499, duration: '2-3 hours' },
      { name: 'Panel Painting', price: 3499, duration: '1-2 days' },
      { name: 'Full Body Painting', price: 14999, duration: '3-5 days' }
    ]
  },
  {
    id: '4',
    name: 'Batteries',
    icon: 'Battery',
    description: 'Battery replacement and maintenance',
    image: 'https://images.unsplash.com/photo-1551522435-a13afa10f103?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwxfHxnYXJhZ2V8ZW58MHx8fHwxNzYxODMzMDAzfDA&ixlib=rb-4.1.0&q=85',
    popular: false,
    packages: [
      { name: 'Amaron Battery', price: 4499, duration: '30 mins' },
      { name: 'Exide Battery', price: 4299, duration: '30 mins' },
      { name: 'Premium Battery', price: 6999, duration: '30 mins' }
    ]
  },
  {
    id: '5',
    name: 'Car Spa & Cleaning',
    icon: 'Sparkles',
    description: 'Deep cleaning and detailing services',
    image: 'https://images.pexels.com/photos/162553/keys-workshop-mechanic-tools-162553.jpeg',
    popular: false,
    packages: [
      { name: 'Express Wash', price: 499, duration: '30 mins' },
      { name: 'Premium Spa', price: 1999, duration: '2-3 hours' },
      { name: 'Complete Detailing', price: 4999, duration: '4-5 hours' }
    ]
  },
  {
    id: '6',
    name: 'Wheel Care',
    icon: 'Circle',
    description: 'Wheel alignment, balancing, and tire services',
    image: 'https://images.unsplash.com/photo-1615906655593-ad0386982a0f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwxfHxtZWNoYW5pY3xlbnwwfHx8fDE3NjE4MzI5OTJ8MA&ixlib=rb-4.1.0&q=85',
    popular: false,
    packages: [
      { name: 'Wheel Alignment', price: 899, duration: '1 hour' },
      { name: 'Wheel Balancing', price: 699, duration: '1 hour' },
      { name: 'Tire Replacement', price: 4999, duration: '1-2 hours' }
    ]
  }
];

export const carBrands = [
  'Maruti Suzuki', 'Hyundai', 'Tata', 'Mahindra', 'Honda',
  'Toyota', 'Kia', 'Ford', 'Volkswagen', 'Skoda',
  'Renault', 'Nissan', 'MG', 'Jeep', 'BMW'
];

export const carModels = {
  'Maruti Suzuki': ['Swift', 'Baleno', 'Dzire', 'Wagon R', 'Alto', 'Vitara Brezza', 'Ertiga'],
  'Hyundai': ['i20', 'Creta', 'Venue', 'Verna', 'Grand i10', 'Alcazar', 'Exter'],
  'Tata': ['Nexon', 'Punch', 'Harrier', 'Safari', 'Altroz', 'Tiago'],
  'Mahindra': ['XUV700', 'Scorpio', 'Thar', 'XUV300', 'Bolero'],
  'Honda': ['City', 'Amaze', 'Jazz', 'WR-V', 'Civic'],
  'Toyota': ['Fortuner', 'Innova', 'Glanza', 'Urban Cruiser', 'Camry'],
  'Kia': ['Seltos', 'Sonet', 'Carens', 'EV6'],
  'Ford': ['EcoSport', 'Endeavour', 'Figo', 'Aspire'],
  'Volkswagen': ['Polo', 'Vento', 'Tiguan', 'T-Roc'],
  'Skoda': ['Kushaq', 'Slavia', 'Octavia', 'Superb'],
  'Renault': ['Kwid', 'Triber', 'Kiger', 'Duster'],
  'Nissan': ['Magnite', 'Kicks', 'GT-R'],
  'MG': ['Hector', 'Astor', 'ZS EV', 'Gloster'],
  'Jeep': ['Compass', 'Meridian', 'Wrangler'],
  'BMW': ['3 Series', '5 Series', 'X1', 'X3', 'X5']
};

export const testimonials = [
  {
    id: '1',
    name: 'Rajesh Kumar',
    location: 'Koramangala, Bangalore',
    rating: 5,
    comment: 'Excellent service! My car feels brand new after the complete servicing. The pickup and drop facility was very convenient.',
    service: 'Periodic Service',
    date: '2025-06-15'
  },
  {
    id: '2',
    name: 'Priya Sharma',
    location: 'Whitefield, Bangalore',
    rating: 5,
    comment: 'Very professional team. They fixed my AC issue quickly and the pricing was transparent. Highly recommended!',
    service: 'AC Repair',
    date: '2025-06-20'
  },
  {
    id: '3',
    name: 'Amit Patel',
    location: 'Indiranagar, Bangalore',
    rating: 4,
    comment: 'Good service quality. The denting and painting work was done perfectly. Took a bit longer than expected but worth the wait.',
    service: 'Denting & Painting',
    date: '2025-06-25'
  },
  {
    id: '4',
    name: 'Sneha Reddy',
    location: 'Jayanagar, Bangalore',
    rating: 5,
    comment: 'Best car service experience in Bangalore! The mechanics are well-trained and the workspace is clean and professional.',
    service: 'Comprehensive Service',
    date: '2025-06-28'
  }
];

export const features = [
  {
    id: '1',
    icon: 'Truck',
    title: 'Free Pickup & Drop',
    description: 'We pick up your car from your doorstep and deliver it back after service'
  },
  {
    id: '2',
    icon: 'ShieldCheck',
    title: 'Certified Mechanics',
    description: 'All our mechanics are trained and certified professionals'
  },
  {
    id: '3',
    icon: 'BadgeCheck',
    title: 'Genuine Parts',
    description: 'We use only genuine OEM and OES parts for your car'
  },
  {
    id: '4',
    icon: 'Clock',
    title: 'On-Time Service',
    description: 'We value your time and ensure timely service delivery'
  },
  {
    id: '5',
    icon: 'Receipt',
    title: 'Transparent Pricing',
    description: 'No hidden charges. What you see is what you pay'
  },
  {
    id: '6',
    icon: 'Award',
    title: '6 Month Warranty',
    description: 'All our services come with a 6-month warranty'
  }
];

export const bangaloreLocations = [
  'Koramangala', 'Whitefield', 'Indiranagar', 'HSR Layout',
  'Marathahalli', 'Electronic City', 'Jayanagar', 'BTM Layout',
  'Banashankari', 'Rajajinagar', 'Malleshwaram', 'Yelahanka',
  'Hebbal', 'Sarjapur Road', 'Bellandur', 'JP Nagar'
];

export const blogs = [
  {
    id: '1',
    title: '10 Signs Your Car Needs Servicing',
    excerpt: 'Learn about the common signs that indicate your car needs immediate attention...',
    image: 'https://images.unsplash.com/photo-1487754180451-c456f719a1fc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHw0fHxjYXIlMjBzZXJ2aWNlfGVufDB8fHx8MTc2MTgzMjk4N3ww&ixlib=rb-4.1.0&q=85',
    date: '2025-06-15',
    category: 'Maintenance'
  },
  {
    id: '2',
    title: 'Car AC Maintenance Tips for Bangalore Weather',
    excerpt: 'Keep your car AC running efficiently with these simple maintenance tips...',
    image: 'https://images.unsplash.com/photo-1615906655593-ad0386982a0f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwxfHxtZWNoYW5pY3xlbnwwfHx8fDE3NjE4MzI5OTJ8MA&ixlib=rb-4.1.0&q=85',
    date: '2025-06-20',
    category: 'Tips'
  },
  {
    id: '3',
    title: 'How to Choose the Right Service Package',
    excerpt: 'A comprehensive guide to selecting the perfect service package for your car...',
    image: 'https://images.unsplash.com/photo-1727893119356-1702fe921cf9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwyfHxjYXIlMjBzZXJ2aWNlfGVufDB8fHx8MTc2MTgzMjk4N3ww&ixlib=rb-4.1.0&q=85',
    date: '2025-06-25',
    category: 'Guide'
  }
];
